// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609142004/js/" + chunkId + "." + {"44":"e2b29f35","225":"0f086afa","481":"09801fb5","486":"cf11b160","770":"1ed74746"}[chunkId] + ".0.9167372262950523.chunk.js";
};